export default function RadioInput({ question, value, onChange, error }) {
  return (
    <div className="flex flex-col gap-3">
      {question.options.map((opt) => {
        const isSelected = value === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(question.id, opt.value)}
            className={`group flex items-center gap-4 px-5 py-4 rounded-xl border text-left
              transition-all duration-300 cursor-pointer
              ${
                isSelected
                  ? "bg-white/10 border-white/40"
                  : "bg-white/[0.02] border-white/10 hover:bg-white/[0.06] hover:border-white/20"
              }`}
          >
            <div
              className={`flex-shrink-0 w-5 h-5 rounded-full border-2 flex items-center justify-center
                transition-all duration-300
                ${isSelected ? "border-white" : "border-white/30 group-hover:border-white/50"}`}
            >
              {isSelected && (
                <div className="w-2.5 h-2.5 rounded-full bg-white" />
              )}
            </div>
            <span
              className={`font-sans text-sm desktop:text-base transition-colors duration-300
                ${isSelected ? "text-white" : "text-white/70 group-hover:text-white/90"}`}
            >
              {opt.label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
